import style from './CommentsBlockPreview.module.scss'
import { formatOrdinalDate, formatShortDate } from '../../../../../util'
import { useModuleCopy } from '../../../../../context/ModuleContext'
import { ReportBlockPreview } from '../ReportBlockPreview'
import { useCommentsDefault } from './config'

/**
 * @param {import('./CommentsBlockPreview.types').CommentsBlockPreviewProps} props
 */
export const CommentsBlockPreview = ({ title = '', dateRange: { from, to }, criteriaComments }) => {
  const { from: defaultFrom, to: defaultTo } = useCommentsDefault()
  const formattedFrom = formatOrdinalDate(from || defaultFrom)
  const formattedTo = formatOrdinalDate(to || defaultTo)

  return (
    <ReportBlockPreview>
      <div className={style['comments-block']}>
        <h2>{title}</h2>
        <p>
          Comments for audits completed between the {formattedFrom} and the {formattedTo}
        </p>
        <CriteriaComments comments={criteriaComments} />
      </div>
    </ReportBlockPreview>
  )
}

/** @param {import('./CommentsBlockPreview.types').CriteriaCommentsProps} props */
const CriteriaComments = ({ comments }) => {
  const {
    textCopy: {
      criteria: { label: criteriaLabel = 'criteria' }
    },
    capitalize
  } = useModuleCopy()

  return (
    <>
      <h3>{capitalize(criteriaLabel)} Comments</h3>
      {comments.length > 0 ? <CriteriaCommentList comments={comments} /> : <EmptyCriteriaComments />}
    </>
  )
}

/** @param {import('./CommentsBlockPreview.types').CriteriaCommentListProps} props */
const CriteriaCommentList = ({ comments }) => (
  <ul className={style['theme-comments-list']}>
    {comments.map((comment) => (
      <li key={comment.planInternalId + comment.text}>
        <CriteriaComment {...comment} />
      </li>
    ))}
  </ul>
)

/** @param {import('./CommentsBlockPreview.types').CriteriaComment} props */
const CriteriaComment = ({ text, planInternalId, commenterName, commentDate }) => {
  const renderedText = `"${text}" - ${planInternalId} (${commenterName}, ${formatShortDate(commentDate)})`
  return <span>{renderedText}</span>
}

const EmptyCriteriaComments = () => {
  const {
    textCopy: {
      criteria: { label: criteriaLabel = 'criteria' }
    }
  } = useModuleCopy()

  return <p>There are no {criteriaLabel} comments</p>
}
